// extracted by mini-css-extract-plugin
export default {"primaryColor":"#e24522","appBackgroundColorOffWhite":"#f8feff","panelColor":"#f9fafb"};